@if (optionGroup$) {
  <motn-popover-multi-select
    [optionGroup$]="optionGroup$"
    [multiOrSingle]="multiOrSingle"
    [inputPlaceholder]="'Hub Name or ID'"
    (clickedOutsideMenu$)="clickedOutsideMenu$.emit()"
    (clickedOption$)="onSelectHub($event)"
    [overlayPositions]="overlayPositions"
  ></motn-popover-multi-select>
}
